import React from 'react';
import { Title } from '../../typography';
import { ButtonPrimary, ButtonSecondary } from '../../atoms/Button';

type PageHeadingProps = {
  pageTitle: string;
  mainButtonText?: string;
  mainOnClick?: () => void;
  mainHref?: string;
  secondaryButtonText?: string;
  secondaryOnClick?: () => void;
  secondaryHref?: string;
};

export function PageHeading({
  pageTitle,
  mainButtonText,
  mainOnClick,
  mainHref,
  secondaryButtonText,
  secondaryOnClick,
  secondaryHref,
}: PageHeadingProps) {
  return (
    <div className="flex items-center justify-between gap-4">
      <Title size="medium">{pageTitle}</Title>
      <div className="flex gap-4 whitespace-nowrap">
        {!!mainButtonText && (
          <ButtonPrimary onClick={mainOnClick} {...(mainHref && { href: mainHref })}>
            {mainButtonText}
          </ButtonPrimary>
        )}
        {!!secondaryButtonText && (
          <ButtonSecondary onClick={secondaryOnClick} {...(secondaryHref && { href: secondaryHref })}>
            {secondaryButtonText}
          </ButtonSecondary>
        )}
      </div>
    </div>
  );
}
